import { supplierConstants } from '../_constants';

const initialState = {
  suppliers: [],
  errors: {}
};


export function supplier(state = initialState, action) {
  switch (action.type) {

  case supplierConstants.SUPPLIER_OPTIONS_LOADED:
    return Object.assign({}, state, { options: action.data.actions.POST });

  case supplierConstants.SUPPLIERS_LOADED:
    return Object.assign({}, state, { suppliers: action.data.results});

  case supplierConstants.SUPPLIER_CREATED:
    let { suppliers } = state;
    suppliers.unshift(action.data);
    return Object.assign({}, state, { suppliers, message: 'Supplier successfully created.' });

  case supplierConstants.SUPPLIER_LOADED:
    return Object.assign({}, state, { supplier: action.data});

  case supplierConstants.SUPPLIER_UPDATED:
    suppliers = state.suppliers.slice();
    let idx = suppliers.findIndex(item => item.id === action.data.id);
    suppliers[idx] = action.data;
    return Object.assign({}, state, { suppliers, message: 'Supplier successfully updated.' });

  case supplierConstants.SUPPLIER_ERRORS:
    return Object.assign({}, state, { errors: action.errors });

  case supplierConstants.SUPPLIER_DELETED:
    suppliers = state;
    idx = suppliers.findIndex(item => item.id === action.data.id);
    delete suppliers[idx];
    return Object.assign({}, state, { suppliers, message: 'Supplier successfully deleted.' });

  case supplierConstants.SUPPLIER_RESET:
    return Object.assign({}, state, { message: '', errors: {} });

  case 'ACCOUNTS_LOADED':
    return Object.assign({}, state, { accounts: action.data.results });

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/supplier.reducer.js